import { Component, Input, OnInit } from '@angular/core';
import { EveReportingWidget, EveReportingWidgetType } from '../../widget.component';




@Component({
  selector: 'widget-type-menu-settings',
  templateUrl: 'widget-type-menu-settings.component.html',
  styleUrls: ['./widget-type-menu-settings.component.css']
})
export class WidgetTypeMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingWidget = null;

  widgetTypes = EveReportingWidgetType;


  constructor(

  ) {


  }
    ngOnInit(): void {
    }


}



